import { render, staticRenderFns } from "./SpoilerText.vue?vue&type=template&id=56f8700b&"
import script from "./SpoilerText.vue?vue&type=script&lang=js&"
export * from "./SpoilerText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports